import { Property } from '../../../types';
import { HealthIssue } from '../../../types/inventoryHealth';
import { validateCityCoordinates } from '../colombiaGeoBounds';

export function checkGeoConsistencyRule(property: Property): HealthIssue | null {
  const result = validateCityCoordinates(property.ciudad, property.latitude, property.longitude);

  if (!result.valid) {
    const coordsStr =
      property.latitude && property.longitude
        ? `[${property.latitude.toFixed(4)}, ${property.longitude.toFixed(4)}]`
        : 'Sin coordenadas';

    return {
      ruleId: 'geo_city_mismatch',
      ruleName: 'Inconsistencia Ciudad vs. Coordenadas',
      severity: 'critical',
      message: `${result.reason}. Ciudad registrada: "${property.ciudad || 'No especificada'}". Coords: ${coordsStr}.`,
      field: 'geo',
      currentValue: coordsStr,
      suggestedFix: 'Ajustar la latitud y longitud o verificar la ciudad asignada en el inmueble.',
    };
  }

  return null;
}
